import LinkHighlightInput from './LinkHighlightInput';

export default LinkHighlightInput;
